export default "__VITE_ASSET__Dq3APr1c__"